import { render } from "./loaderComponent.vue?vue&type=template&id=01d3c3e4"
import script from "./loaderComponent.vue?vue&type=script&lang=js"
export * from "./loaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/loaderComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01d3c3e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01d3c3e4', __exports__)) {
    api.reload('01d3c3e4', __exports__)
  }
  
  module.hot.accept("./loaderComponent.vue?vue&type=template&id=01d3c3e4", () => {
    api.rerender('01d3c3e4', render)
  })

}


export default __exports__